(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poppi-nutrition-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poppi-nutrition-tabs')) {
    class PoppiNutritionTabs extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('[data-poppi-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-poppi-panel]'));
        const options = { signal: this.abortController.signal };

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, false), options);
        });
        this.addEventListener('keydown', (event) => this.handleKeydown(event), options);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      select(index, focusTab) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focusTab) tab.focus();
        });

        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.toggleAttribute('inert', !active);
        });
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-poppi-tab]');
        if (!tab) return;
        const current = this.tabs.indexOf(tab);
        let next = current;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === current) return;

        event.preventDefault();
        this.select(next, true);
      }
    }

    customElements.define('poppi-nutrition-tabs', PoppiNutritionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
